import { useAtom, WritableAtom } from 'jotai';
import React, { SetStateAction } from 'react';
import { getFilterLabelBaseOnMnoStatus, MNOStatusFilter } from '../Sim/constants/mnoStatus';
import { FilterChip } from './FilterChip';
import { useTranslation } from 'react-i18next';

type MnosChipsProps = {
  mnoStatusAtom: WritableAtom<MNOStatusFilter[], [SetStateAction<MNOStatusFilter[]>], void>;
};

export const MnoStatusChips = ({ mnoStatusAtom }: MnosChipsProps) => {
  const { t } = useTranslation();
  const [mnoStatuses, setMNOStatus] = useAtom(mnoStatusAtom);

  const onClear = (status: MNOStatusFilter) => {
    setMNOStatus((currentMNOStatus) =>
      currentMNOStatus.filter((mnoStatus) => mnoStatus !== status),
    );
  };

  if (mnoStatuses.length === 0) {
    return null;
  }

  return (
    <>
      {mnoStatuses.map((status) => {
        return (
          <React.Fragment key={status}>
            <FilterChip
              text={`${t('simInventory.mnoStatus')}: ${getFilterLabelBaseOnMnoStatus(status, t)}`}
              onClose={() => {
                onClear(status);
              }}
            />
          </React.Fragment>
        );
      })}
    </>
  );
};
